import CurrencyTable from "./CurrencyTable";
import CoinTable from "./CoinTable"
import NimaiiTable from "./NimaiiTable";
import CryptoTable from "./CryptoTable";
import {useContext} from "react"
import {DataContext} from "../index"
import loading from '../assets/images/bars.svg'

function Tables(){
    const dataContext=useContext(DataContext)

    return( 
        <>
            <section className="table-container">
            {dataContext.currencyPrice? <CurrencyTable/>:<img style={{ display: 'block', margin: '3em auto 0' }} src={loading} />}
            {/* <CurrencyTable/> */}
            <div className="another-tables">
            {dataContext.coinPrice? <CoinTable/>:<img style={{ display: 'block', margin: '3em auto 0' }} src={loading} />}
            {/* <CoinTable/> */}
            {dataContext.nimaiiPrice? <NimaiiTable/>:<img style={{ display: 'block', margin: '3em auto 0' }} src={loading} />}
            {/* <CryptoTable/> */}
            {/* {dataContext?.cryptoPrice?.BTC? <CryptoTable/>:<img style={{ display: 'block', margin: '3em auto 0' }} src={loading} />} */}
            </div>
            </section>
        </>
    )
}

export default Tables;